/* NicheGems review pop-ups: shows the real FragranceGems shop reviews that sections/ng-review-toast.liquid
   printed as JSON. Fetches no review data, sends nothing. */
(function () {
  'use strict';
  var KEY = 'ngReviewToast', SES = 'sessionStorage', MEM = 'localStorage';
  var BLOCKERS = '#shopify-pc__banner,#shopify-pc__prefs,dialog[open],.menu-drawer-container[open]';
  var FOOTER = '.ng-footer'; /* sections/ng-footer.liquid: country select and bottom links must stay free */
  var timer;
  function load(store) { return JSON.parse(window[store].getItem(KEY) || '{}'); }
  function save(store, value) { try { window[store].setItem(KEY, JSON.stringify(value)); return 1; } catch (e) {} }
  /* the 7-day memory (d closes, u quiet until): only while Shopify's consent API allows preferences */
  function memory() {
    try {
      if (window.Shopify.customerPrivacy.preferencesProcessingAllowed()) return load(MEM);
      window[MEM].removeItem(KEY);
    } catch (e) {}
  }
  function init() {
    var root = document.getElementById('NgReviewToast'), json = document.getElementById('NgReviewToastData');
    clearInterval(timer);
    if (!root || !json || (navigator.connection || {}).saveData) return;
    var d = root.dataset, card = root.firstElementChild, footer = document.querySelector(FOOTER);
    var demo = 'demo' in d; /* theme editor: no limits */
    var hover = ':focus-within' + (matchMedia('(hover:hover)').matches ? ',:hover' : '');
    var left = 0; /* seconds the open pop-up stays */
    var list, ses, wait, css;
    try {
      list = JSON.parse(json.textContent);
      ses = load(SES); /* this visit: v views, n shown, x closed, t last shown, i next review */
    } catch (e) {
      return;
    }
    ses.v = (ses.v || 0) + 1;
    /* without storage a close cannot be remembered: show nothing */
    if (!save(SES, ses) || !list.length || (!demo && (ses.x || ses.n >= d.max))) return;
    /* seconds to the next pop-up; the interval also holds across pages */
    wait = demo ? 3 : Math.max(ses.v > 1 ? d.delay : d.first, d.every - (Date.now() - (ses.t || 0)) / 1e3);

    function part(key) { return card.querySelector('[data-' + key + ']'); }
    /* something that matches is on screen; with top: its lower edge has not yet passed the top of the window */
    function seen(selector, top) {
      return [].some.call(document.querySelectorAll(selector), function (el) {
        return top ? el.getBoundingClientRect().bottom > 0 : el.getClientRects().length;
      });
    }
    /* cookie banner, menu, search or cart open, a form field in use, off on this screen, the footer on screen,
       or the top of the page not yet scrolled past where the section asks for that (data-gate, data-gate-mq) */
    function blocked() {
      var a = document.activeElement;
      return !root.getClientRects().length || /^(INPUT|TEXTAREA|SELECT)$/.test(a && a.tagName) || seen(BLOCKERS) ||
        (footer && footer.getBoundingClientRect().top < window.innerHeight) ||
        (!demo && d.gate && matchMedia(d.gateMq).matches && seen(d.gate, 1));
    }
    function stop() {
      ses.x = 1;
      save(SES, ses);
      clearInterval(timer);
    }
    function show() {
      var mem = memory(), i = ses.i == null ? Math.random() * list.length | 0 : ses.i, r = list[i % list.length], q = part('t');
      var old = part('p'); /* a page from the cache may still carry the former product line */
      if (!demo && mem && mem.u > Date.now()) return stop(); /* closed twice in the last 7 days */
      if (old) old.textContent = r.p || '';
      q.textContent = r.t;
      q.lang = r.l;
      part('a').textContent = r.a;
      part('m').hidden = !r.m;
      part('s').textContent = d.stars.replace('%', r.r);
      part('r').style.setProperty('--ng-stars', r.r * 20 + '%');
      card.hidden = false;
      card.offsetWidth; /* reflow, so the transition runs */
      card.classList.add('is-in');
      left = +d.stay;
      ses.i = i + 1;
      ses.n = (ses.n || 0) + 1;
      ses.t = Date.now();
      save(SES, ses);
    }
    function hide() {
      left = 0;
      wait = d.every - d.stay;
      card.classList.remove('is-in');
      setTimeout(function () { if (!left) card.hidden = true; }, 450);
      if (!demo && (ses.x || ses.n >= d.max)) clearInterval(timer);
    }
    function close() {
      var mem = memory();
      if (mem) {
        mem.d = (mem.d || 0) + 1;
        if (mem.d > 1) { mem.d = 0; mem.u = Date.now() + 6048e5; } /* twice: quiet for 7 days */
        save(MEM, mem);
      }
      ses.x = 1;
      save(SES, ses);
      hide();
    }
    function tick() {
      if (document.hidden) return;
      if (left) {
        if (blocked()) hide();
        else if (card.matches(hover)) left = Math.max(left, 2);
        else if (!--left) hide();
      } else if (--wait <= 0) {
        if (blocked()) wait = 3;
        else show();
      }
    }
    card.querySelector('button').onclick = close;
    card.onkeydown = function (e) { if (e.key === 'Escape') close(); };
    /* an open pop-up leaves the moment the footer comes on screen (the clock would take up to a second) */
    if (footer && window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        if (left && entries[entries.length - 1].isIntersecting) hide();
      }).observe(footer);
    }
    /* Shopify's consent API and the stylesheet load only now; then the clock starts */
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (e) {}
    css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = d.css;
    css.onload = function () { timer = setInterval(tick, 1e3); };
    document.head.appendChild(css);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
